import { restClient } from '../../client';
import { Match, User, UserProfile, Appointment } from '../../resources';

export const enum PatientMatchStatus {
  active = 'active',
  rematched = 'rematched',
  discharged = 'discharged',
  inactive = 'inactive',
}

export type ClientsWithAppointmentListInput = {
  all_matching_states?: boolean;
};

export type ClientsWithAppointment = {
  match: Match;
  lastAppointment?: Appointment;
  nextAppointment?: Appointment;
  status: PatientMatchStatus;
  patient: User;
  patient_profile: UserProfile;
};

export type ClientsWithAppointmentListOutput = {
  data: ClientsWithAppointment[];
};

export const clientsWithAppointmentList = restClient.createRequest<ClientsWithAppointmentListInput, ClientsWithAppointmentListOutput>({
  url: '/api/v1/provider/clients_with_appointments',
  method: 'POST',
});
